module.exports = __webpack_public_path__ + "img/block-block-title.c8a9e810.png";